<template>
  <el-dialog
    :title="$t('message.additionalServices')"
    :visible.sync="visible"
    width="1000px"
    append-to-body
    center
    :close-on-click-modal="false"
  >
    <div class="option">
      <div class="table">
        <ol>
          <li class="flex15">{{ $t("message.additionalServiceOptions") }}</li>
          <li class="flex15">{{ $t("message.additionalServicesJapanese") }}</li>
          <li>{{ $t("message.number") }}</li>
          <li class="flex15">{{ $t("message.actualCharges") }}</li>
          <li>{{ $t("message.estimatedCost") }}({{ $t('message.unit') }})</li>
        </ol>
        <ul v-for="(item, index) in optionsList" :key="index" v-show="item.show">
          <li class="flex15">
            <div class="checkbox" v-if="item.edit">
              <el-checkbox v-model="item.checked" @change="checkedNum"></el-checkbox>
              <div class="input">
                <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
              </div>
            </div>
            <div class="checkbox" v-else>
              <el-checkbox v-model="item.checked" @change="checkedNum">({{ index + 1 }}) {{ item.name }}</el-checkbox>
            </div>
          </li>
          <li class="flex15">
            <el-input
              v-if="item.edit"
              v-model="item.name_translate"
              size="small"
              onfocus="this.select()"
              :placeholder="$t('message.additionalServicesJapanese')"
            ></el-input>
            <span v-else>{{ item.name_translate }}</span>
          </li>
          <li>
            <el-input v-model="item.num" size="small" onfocus="this.select()" @input="handleInput(item.num, index)"></el-input>
          </li>
          <li class="flex15">
            <div class="template">
              <div class="input">
                <el-input v-if="item.edit" v-model="item.price" size="small" onfocus="this.select()" type="number"></el-input>
                <span v-else>{{ item.price }}</span>
              </div>
              {{ item.unit }}
            </div>
          </li>
          <li>
            <span class="total">
              <span v-if="item.price_type == 0">{{ item.checked ? ceil(item.price * item.num) : 0 }}</span>
              <span v-else>{{ item.checked ? ceil(item.price * goodsAmount / 100) : 0 }}</span>
            </span>
            <el-button size="mini" type="success" class="dark fr" v-if="item.edit" @click="delItem(index)">
              {{ $t("message.delete") }}
            </el-button>
          </li>
        </ul>
        <div class="operation">
          <el-button size="mini" type="success" @click="add">新增自定义OPTION</el-button>
          <el-button type="primary" size="mini" @click="show = !show">
            {{ show ? '收起' : '查看更多OPTION' }}
          </el-button>
        </div>
        <div :class="{ isShow: show }" class="showList">
          <ul v-for="(item, index) in optionsList" :key="'hide-' + index" v-show="!item.show">
            <li class="flex15">
              <div class="checkbox" v-if="item.edit">
                <el-checkbox v-model="item.checked" @change="checkedNum"></el-checkbox>
                <div class="input">
                  <el-input v-model="item.name" size="small" onfocus="this.select()"></el-input>
                </div>
              </div>
              <div class="checkbox" v-else>
                <el-checkbox v-model="item.checked" @change="checkedNum">{{ item.name }}</el-checkbox>
              </div>
            </li>
            <li class="flex15">
              <el-input
                v-if="item.edit"
                v-model="item.name_translate"
                size="small"
                onfocus="this.select()"
                :placeholder="$t('message.additionalServicesJapanese')"
              ></el-input>
              <span v-else>{{ item.name_translate }}</span>
            </li>
            <li>
              <el-input v-model="item.num" size="small" onfocus="this.select()" @input="handleInput(item.num, index)"></el-input>
            </li>
            <li class="flex15">
              <div class="template">
                <div class="input">
                  <el-input v-if="item.edit" v-model="item.price" size="small" onfocus="this.select()" type="number"></el-input>
                  <span v-else>{{ item.price }}</span>
                </div>
                {{ item.unit }}
              </div>
            </li>
            <li>
              <span class="total">
                <span v-if="item.price_type == 0">{{ item.checked ? ceil(item.price * item.num) : 0 }}</span>
                <span v-else>{{ item.checked ? ceil(item.price * goodsAmount / 100) : 0 }}</span>
              </span>
              <el-button size="mini" type="success" class="dark fr" v-if="item.edit" @click="delItem(index)">
                {{ $t("message.delete") }}
              </el-button>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t("message.cancel") }}</el-button>
      <el-button type="primary" @click="save">{{ $t("message.save") }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
/**
 * 下单方案附加服务弹框
 * 合并系统 OPTION 和当前方案的已选/自定义 OPTION，确认后仅回传有效勾选项。
 */
export default {
  name: 'OrderOptionDialog',
  data() {
    return {
      visible: false, // 弹框显隐
      show: false, // 是否展开第 10 项之后的 OPTION
      optionsList: [], // 系统 OPTION 与已选自定义 OPTION 的合并列表
      goodsAmount: 0, // 商品金额，用于百分比计价
      goodsNum: 0 // 商品数量，勾选按件时作为默认服务数量
    }
  },
  methods: {
    /**
     * 打开弹框并重新拉取客户可用 OPTION。
     * @param {Array} checkedOptions 当前商品已选服务
     * @param {Object} goods 当前商品，需含 price、num
     * @param {Object} detail 商品上下文，需含 user_id
     */
    open(checkedOptions, goods, detail) {
      this.visible = true
      this.show = false
      this.optionsList = []
      this.goodsAmount = goods.price * goods.num
      this.goodsNum = goods.num
      this.optionList(checkedOptions, detail)
    },
    optionList(checkedOptions, detail) {
      this.$api.orderApi.orderOptionList({
        need_fix: 1,
        user_id: detail.user_id
      }).then(res => {
        this.optionsList = res.data
        this.setCheckedOptions(checkedOptions)
      })
    },
    // 以名称匹配已选项；不在系统列表中的自定义项需保留并回显。
    setCheckedOptions(checkedOptions) {
      const checkedMap = {}
      checkedOptions.forEach(item => {
        checkedMap[String(item.name || '').trim()] = item
      })
      this.optionsList.forEach((item, index) => {
        const checkedOption = checkedMap[String(item.name || '').trim()]
        item.show = index < 9
        item.edit = item.edit === true || item.price == 0 || item.price == null
        item.checked = false
        item.num = 0
        if (checkedOption) {
          item.checked = checkedOption.checked !== false
          item.num = checkedOption.num
          item.price = checkedOption.price
          item.show = true
        }
      })
      checkedOptions.forEach(item => {
        const name = String(item.name || '').trim()
        const exists = this.optionsList.some(option => String(option.name || '').trim() == name)
        if (!exists) this.optionsList.push({
          ...item,
          checked: item.checked !== false,
          show: true
        })
      })
    },
    add() {
      this.optionsList.push({
        auto_calculate: 0,
        checked: false,
        edit: true,
        is_overstep: 0,
        name: '',
        name_translate: '',
        price_type: 0,
        price: '',
        num: '',
        unit: '元',
        show: true
      })
    },
    delItem(i) {
      this.optionsList.splice(i, 1)
    },
    checkedNum() {
      this.optionsList.forEach(item => {
        if (item.checked) {
          item.show = true
          if (!item.num) item.num = this.goodsNum
        } else {
          item.num = 0
        }
      })
    },
    // 服务数量最多保留两位小数，非法字符直接清理。
    handleInput(value, index) {
      const regex = /^(\d+)?(\.\d{1,2})?$/
      if (!regex.test(value)) {
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('.', '')
        this.optionsList[index].num = this.optionsList[index].num.replaceAll('-', '')
        this.optionsList[index].num = this.optionsList[index].num.replace(/[^\d^]+/g, '')
      }
    },
    /**
     * 回传前校验自定义 OPTION。
     * price_type=1 为百分比计价，其他类型仅保留数量大于 0 的项。
     */
    save() {
      let options = []
      for (let i = 0; i < this.optionsList.length; i++) {
        if (this.optionsList[i].checked) {
          if (this.optionsList[i].name == '') return this.$message.error('option中文名称不能为空')
          if (this.optionsList[i].name_translate == '') return this.$message.error('option日文名称不能为空')
          if (this.optionsList[i].price === '') return this.$message.error(this.optionsList[i].name + 'option价格为空')
          let list = this.optionsList.filter(item => item.name.trim() == this.optionsList[i].name.trim())
          if (list.length > 1) return this.$message.error('option中文名称不能一致可以加个（新）之类的，比如详细检品（新）')
          if (this.optionsList[i].price_type == 1) {
            options.push(this.optionsList[i])
          } else if (this.optionsList[i].num > 0) {
            options.push(this.optionsList[i])
          }
        }
      }
      this.$emit('confirm', options)
      this.visible = false
    },
    ceil(num) {
      return Math.ceil(num * 100) / 100
    }
  }
}
</script>

<style lang="scss" scoped>
.table {
  margin-bottom: 20px;

  ol {
    display: flex;
    height: 40px;
    background: #f8f8f8;
    border-radius: 4px 4px 0 0;
    justify-content: center;
    align-items: center;
    position: sticky;
    top: 0;
    left: 0;
    z-index: 99;

    li {
      height: 40px;
      text-align: center;
    }
  }

  ul {
    display: flex;
    padding: 10px 0;

    .total {
      width: 70%;
      text-align: center;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 15px;

    &:nth-last-child(1) {
      margin-right: 0;
    }
  }

  .flex15 {
    flex: 1.5;
  }

  .checkbox {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0 10px;

    .input {
      width: 160px;
      margin-left: 10px;
    }
  }

  .template {
    display: flex;
    flex-wrap: wrap;
    line-height: 32px;

    .input {
      width: 140px;
      margin-right: 10px;
    }
  }
}

.operation {
  margin-top: 10px;

  .el-button {
    margin-right: 220px;
  }
}

.showList {
  transition: all 0.3s;
  height: 0;
  overflow: hidden;
}

.isShow {
  height: auto;
}
</style>
